export default "__VITE_ASSET__DOrgnT8R__"